import styled from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;
`;
